<button
  aria-haspopup="true"
  aria-controls="menu"
  type="button"
  class="flex h-full items-center gap-2 rounded-3xl pl-2 font-medium"
  [class]="buttonTheme()"
  (click)="onExpandCollapse()"
  (mouseover)="onHover()"
>
  <span>{{ text() }}</span>
  <rma-icon
    role="menu"
    class="rma-menu-indicator"
    [class.rma-menu-indicator--expanded]="indicator() === 'expanded'"
    glyph="expand_more"
  />
</button>

@if (mode() === 'inline' && indicator() === 'expanded') {
  <ng-content />
}
